/**
 * 联系人管理标签数据接口文档
 */
import { Method } from '../core';
import { API, SOURCE } from '../config';

const api = API;

export default {
  // 分页获取联系人列表
  getContactList: {
    url: `${api}/rest/v1/contact/list`,
    method: Method.GET,
    body: {
      page: {
        $type: Number,
        $required: true
      },
      pageSize: {
        $type: Number,
        $required: true
      },
      source: {
        $type: String,
        $default: SOURCE
      },
      condition: {
        $type: [String, Number]
      }
    }
  },
  // 添加联系人
  addContacts: {
    url: `${api}/rest/v1/contact/add`,
    method: Method.POST,
    body: {
      account: {
        $type: String,
        $required: true
      },
      nickname: {
        $type: String,
        $required: true
      },
      comments: {
        $type: String
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  // 更新联系人
  updateContacts: {
    url: `${api}/rest/v1/contact/update`,
    method: Method.PUT,
    body: {
      contactId: {
        $type: String,
        $required: true
      },
      account: {
        $type: String,
        $required: true
      },
      nickname: {
        $type: String,
        $required: true
      },
      source: {
        $type: String,
        $default: SOURCE
      },
      comments: {
        $type: String
      }
    }
  },
  // 删除联系人
  deleteContacts: {
    url: `${api}/rest/v1/contact/delete`,
    method: Method.DELETE,
    body: {
      contactId: {
        $type: String,
        $required: true
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/resource-api/api/contact.js